import * as React from "react";
import styled, { css } from "styled-components";
import { Col, Row, HelpBlock } from "components/bootstrap";
import { StatusIcon } from "components/common";
const StyledRow = styled(Row)`
  &:not(:last-child) {
    margin-bottom: 7px;
  }
`;
const LabelCol = styled(Col)(
  ({ theme }) => css`
    font-weight: bold;

    @media (min-width: ${theme.breakpoints.min.md}) {
      text-align: right;
    }
  `
);
const readableValue = (value) => {
  if (typeof value === "boolean") {
    return /* @__PURE__ */ React.createElement(StatusIcon, { active: value });
  }
  if (value) {
    return value;
  }
  return "-";
};
const ReadOnlyFormGroup = ({ label, value, help = void 0, className = void 0 }) => /* @__PURE__ */ React.createElement(StyledRow, { className }, /* @__PURE__ */ React.createElement(LabelCol, { sm: 3 }, label), /* @__PURE__ */ React.createElement(Col, { sm: 9, className: "read-only-value-col" }, readableValue(value), help && /* @__PURE__ */ React.createElement(HelpBlock, null, help)));
export default ReadOnlyFormGroup;
